import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormError } from ".";
import { FileUpload } from "../ui";

interface Props {
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  onChange: (files: FileList | null) => void;
  defaultValue: FileList | null;
  multiple?: boolean;
  name: string;
}
export default function FormFilesUploadInput({
  label,
  required,
  errors,
  defaultValue,
  onChange,
  multiple,
  name,
}: Props) {
  return (
    <div>
      <label className="space-y-1 capitalize">
        <div
          className={cn("text-base font-medium", {
            "text-danger-500": errors?.error,
          })}
        >
          {label} {required && <span className="text-danger-400">*</span>}
        </div>

        <FileUpload
          name={name}
          onChange={onChange}
          defaultValue={defaultValue}
          multiple={multiple}
        />
        <FormError error={errors?.error} message={errors?.message} />
      </label>
    </div>
  );
}
